export interface PointsByPosition {
    position: number;
    points: number;
}

export interface PointsByRaceConfiguration {
    id: string;
    name: string;
    pointsByPositions: PointsByPosition[];
}

export const PointsByRaceConfigurationFormDefault: PointsByRaceConfiguration = {
    id: "",
    name: "",
    pointsByPositions: [],
};
